// extracted by mini-css-extract-plugin
module.exports = {"AddQuestion":"AdminPage_AddQuestion__3gz1c"};